import api from 'app/actions/api';
import { DietFoodTypeId } from 'app/dataTypes/org/dietFoodTypes'

export const ITEMSEDIT_REQUEST = 'orgs/kits/ITEMSEDIT_REQUEST';
export const ITEMSEDIT_SUCCESS = 'orgs/kits/ITEMSEDIT_SUCCESS';
export const ITEMSEDIT_FAILURE = 'orgs/kits/ITEMSEDIT_FAILURE';

type ItemsEditPayload = {
  school_id: string | number;
  complex_id: string | number;
  date: string;
  add_dishes: Array<number>;
  remove_dishes: Array<number>;
  building_id?: number;
  diet_food_type_id?: number;
};

type ItemsEditErrorPayload = {
  err: string;
  error: unknown;
};

export const itemsEditRequest = (payload: ItemsEditPayload) => ({
  type: ITEMSEDIT_REQUEST,
  payload,
});

export const itemsEditSuccess = () => ({
  type: ITEMSEDIT_SUCCESS,
});

export const itemsEditFailure = (payload: ItemsEditErrorPayload) => ({
  type: ITEMSEDIT_FAILURE,
  payload,
});

type Params = {
  date: string;
  kitId: string | number;
  buildingId?: number; // опционально, вариант корпуса
  dietFoodTypeId?: DietFoodTypeId;  // опционально, вариант вида диет. питания
};

export const itemsEdit = (
  orgId: string | number,
  {
    date,
    kitId,
    buildingId,
    dietFoodTypeId,
  }: Params,
  addList: Array<number>,
  removeList: Array<number>,
) => async (dispatch: (action: { type: string; payload?: ItemsEditPayload | ItemsEditErrorPayload }) => void) => {
  const dataToSend: ItemsEditPayload = {
    school_id: orgId,
    complex_id: kitId,
    date,
    add_dishes: addList,
    remove_dishes: removeList,
    building_id: buildingId,
    diet_food_type_id: dietFoodTypeId ? parseInt(dietFoodTypeId, 10) : undefined,
  };
  dispatch(itemsEditRequest(dataToSend));
  try {
    await api('food/menu/complex_items_add_remove', 'post', { data: dataToSend });
    dispatch(itemsEditSuccess());
    return true;
  } catch (error) {
    dispatch(itemsEditFailure({ err: 'Не удалось модифицировать комплект', error }));
    return false;
  }
};
